import Base from '@studiometa/js-toolkit';
import { tns } from 'tiny-slider/src/tiny-slider';
import matrix from '@studiometa/js-toolkit/utils/css/matrix';

/**
 * Slider class.
 */
export default class Slider extends Base {
  /**
   * Class cofnig
   * @return {Object}
   */
  static config = {
    name: 'Slider',
    refs: ['cursor', 'container', 'links[]', 'progress'],
    options: {
      slider: {
        type: Object,
        default: () => ({ nav: false, items: 2 }),
      },
    },
  };

  isEnter = false;

  layerX = 0;

  layerY = 0;

  cursorX = 0;

  cursorY = 0;

  /**
   * Mount slider
   *
   * @return {void}
   */
  mounted() {
    this.slider = tns({
      container: this.$refs.container,
      loop: false,
      controls: false,
      mouseDrag: true,
      navPosition: 'bottom',
      swipeAngle: 70,
      ...this.$options.slider,
    });

    if (this.$refs.progress) {
      this.slider.events.on('indexChanged', (event) => {
        this.updateProgress(event.displayIndex, event.slideCount);
      });

      const { displayIndex, slideCount } = this.slider.getInfo();
      this.updateProgress(displayIndex, slideCount);
    }

    if (this.$refs.cursor) this.$el.addEventListener('mousemove', this.moveCursor, false);
  }

  /**
   * Update progress if it exists
   *
   * @param {import('tiny-slider/src/tiny-slider').TinySliderInfo} event
   */
  updateProgress(current, maxIndex) {
    const currentPercent = current / maxIndex;
    this.$refs.progress.firstElementChild.style.transform = `scaleX(${currentPercent})`;
  }

  /**
   * Update isEnter
   */
  onMouseenter() {
    this.isEnter = true;
  }

  /**
   * Update isEnter prop
   */
  onMouseleave() {
    this.isEnter = false;
  }

  /**
   * Update clientX and clientY properties
   * @param {MouseEvent} event
   */
  onMousemove(event) {
    this.clientX = event.clientX;
    this.clientY = event.clientY;
  }

  /**
   * Move cursor when hover Slider
   * @param  {Object}
   * @return {void}
   */
  ticked() {
    if (!this.isEnter) {
      return;
    }

    this.$refs.cursor.style.transform = matrix({
      translateX: this.clientX - this.$refs.cursor.clientWidth / 2,
      translateY: this.clientY - this.$refs.cursor.clientWidth / 2,
    });
  }

  /**
   * Update cursorX and cursorY position
   * @param {MouseEvent} event
   */
  onMousedown(event) {
    this.cursorX = event.screenX;
    this.cursorY = event.screenY;
  }

  /**
   * Handle the dragging on a link
   * @param {MouseEvent} $event
   */
  onLinksClick(event) {
    if (this.cursorX !== event.screenX || this.cursorY !== event.screenY) {
      event.stopImmediatePropagation();
    }
  }
}
